<template>
  <div class="stripe-elements-container">
    <div class="stripe-element-container stripe-card-number">
      <svg-icon id="creditCard"></svg-icon>
      <label>Card Number <span class="required">*</span></label>
      <div class="inner">
        <div :id="`card-number_${this._uid}`"></div>
      </div>
    </div>
    <div class="stripe-element-container stripe-card-expiry">
      <label>Expiry <span class="required">*</span></label>
      <div class="inner">
        <div :id="`card-expiry_${this._uid}`"></div>
      </div>
    </div>
    <div class="stripe-element-container stripe-card-cvv">
      <label>Card CVC <span class="required">*</span></label>
      <div class="inner">
        <div :id="`card-cvc_${this._uid}`"></div>
      </div>
    </div>
    <div class="form-group submit align-center">
      <button
        type="button"
        class="button loader-button green"
        :class="{ loading: loadingToken || loading }"
        :disabled="loadingToken || loading"
        @click="createToken"
      >
        <svg-icon id="loading" class="spin"></svg-icon>
        Save Card
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { StripePlugin } from "@vue-stripe/vue-stripe";

const options = {
  pk: process.env.MIX_STRIPE_PUBLISHABLE,
  locale: "auto",
};

Vue.use(StripePlugin, options);

export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loadingToken: false,
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
    };
  },
  computed: {
    stripeElements() {
      return this.$stripe.elements();
    },
  },
  mounted() {
    // Style Object documentation here: https://stripe.com/docs/js/appendix/style
    const style = {
      base: {
        color: "black",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "14px",
        "::placeholder": {
          color: "#adadad",
        },
      },
      invalid: {
        color: "#da5050",
        iconColor: "#da5050",
      },
    };
    this.cardNumber = this.stripeElements.create("cardNumber", { style });
    this.cardNumber.mount(`#card-number_${this._uid}`);
    this.cardExpiry = this.stripeElements.create("cardExpiry", { style });
    this.cardExpiry.mount(`#card-expiry_${this._uid}`);
    this.cardCvc = this.stripeElements.create("cardCvc", { style });
    this.cardCvc.mount(`#card-cvc_${this._uid}`);
  },
  beforeDestroy() {
    this.cardNumber.destroy();
    this.cardExpiry.destroy();
    this.cardCvc.destroy();
  },
  methods: {
    async createToken() {
      this.loadingToken = true;
      await this.$stripe
        .createToken(this.cardNumber)
        .then((token) => {
          if (typeof token.error !== "undefined") {
            throw token.error;
          }
          this.$emit("token", token);
          this.cardNumber.clear();
          this.cardExpiry.clear();
          this.cardCvc.clear();
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .then(() => (this.loadingToken = false));
    },
  },
};
</script>
